import { render } from "./OdcrOnline.vue?vue&type=template&id=fd2defa2"
import script from "./OdcrOnline.vue?vue&type=script&lang=js"
export * from "./OdcrOnline.vue?vue&type=script&lang=js"

import exportComponent from "/home/adminhost/web/cr55perjuangan.waroengss.id/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__